import * as Config from "/app/js/common/Config.js";

/**
 * script를 동적으로 로드한다.
 * @param {string} url 로드할 스크립트 URL
 * @return {Promise} - 로드된 스크립트 반환
 * @example
 * import { loadScript } from './Common.js';
 * loadScript('https://openlayers.org/en/v6.4.3/build/ol.js')
     *    .then(() => {
     *      console.log('ol.js loaded');
     *    }
     *    .catch(() => {
     *      console.error('ol.js load failed');
     *    }
 *    );
 */
export const loadScript = function(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = () => resolve(url);
        script.onerror = () => reject(new Error(`Js 로드 실패: ${url}`));
        document.head.appendChild(script);
    });
};


/**
 * style css를 동적으로 로드한다.
 * @param {string} url 로드할 style URL
 * @return {Promise} - 로드된 style 반환
 * @example
 * import { loadStyle } from './Common.js';
 * loadStyle('https://openlayers.org/en/v6.4.3/css/ol.css')
 *    .then(() => {
 *      console.log('ol.css loaded');
 *    }
 *    .catch(() => {
 *      console.error('ol.css load failed');
 *    }
 */
export const loadStyle = function(url) {
    return new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        link.onload = () => resolve(url);
        link.onerror = () => reject(new Error(`Css 로드 실패: ${url}`));
        document.head.appendChild(link);
    });
};

/**
 * 라이브러리를 import시킬 때 사용
 * @param fileList
 */
export const loadLib = function (fileList) {

    const promises = [];

    fileList.filter(file => file.endsWith('.js')).forEach(script => {
        promises.push(() => loadScript(script));
    });

    fileList.filter(file => file.endsWith('.css')).forEach(style => {
        promises.push(() => loadStyle(style));
    });

    // 비동기 작업을 순차적으로 실행
    return promises.reduce((promise, loadFile) => {
        return promise.then(() => loadFile());
    }, Promise.resolve())
        .then(() => {
            return 'success';
        })
        .catch(error => {
            console.error(error);
            return 'fail';
        });
};

/**
 * 체크 세션. 현재 로그인 된 세션이 있는지 서버에서 체크하여 로그인 객체를 리턴받는다. <br>
 * 만약 usrId를 입력하면 해당 아이디에 대한 세션을 체크한다.
 * @param {string} usrId - 체크할 사용자 아이디
 * @return {Object} 로그인 객체
 */
export const checkSession = async function (usrId) {

    const response = await o2.util.Http.requestData("/auth/checkSession");
    const {RESULT, SUCCESS} = response;

    if (!SUCCESS) {
        return false;
    }

    if (usrId) {
        return RESULT.USR_ID === usrId;
    }

    return true;
}

export const getO2Config = async function () {

    const response = await o2.util.Http.requestData("/app/cmmn/env/getO2Config");
    const {RESULT, SUCCESS} = response;

    if (!SUCCESS ) {
        return false;
    } else {
        const utf8Decoder = new TextDecoder("utf-8");
        const decodedText = utf8Decoder.decode(new TextEncoder().encode(JSON.stringify(RESULT))); // 문자열 변환
        const jsonData = JSON.parse(decodedText);
        Object.assign(Config.DATA_CONFIG, jsonData); // Config.DATA_CONFIG에 데이터 적용
        o2.common.Config.DATA_CONFIG = Config.DATA_CONFIG;
    }
}